"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2636,521],{

/***/ 80521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 0;\n  height: 0;\n  overflow: hidden;\n\n  &.adsense-loaded {\n    height: auto;\n    border-top: 8px solid ",
        ";\n    border-bottom: 8px solid ",
        ";\n  }\n\n  &.adsense-failed {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 11px;\n  color: ",
        ";\n  padding: 4px 12px 0;\n  line-height: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px;\n  background: ",
        ";\n  border: 1px dashed ",
        ";\n  border-radius: 8px;\n  margin: 4px 0;\n\n  .dev-ad-icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 8px;\n    background: linear-gradient(\n      135deg,\n      ",
        ",\n      ",
        "\n    );\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n  }\n\n  .dev-ad-content {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .dev-ad-label {\n    font-size: 10px;\n    color: ",
        ";\n    margin-bottom: 2px;\n  }\n\n  .dev-ad-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: ",
        ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .dev-ad-body {\n    font-size: 12px;\n    color: ",
        ";\n    margin-top: 2px;\n  }\n\n  .dev-ad-cta {\n    font-size: 11px;\n    font-weight: 600;\n    color: white;\n    background: ",
        ";\n    border: none;\n    border-radius: 14px;\n    padding: 6px 14px;\n    flex-shrink: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var containerCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), theme.border.space, theme.border.space);
};
var adLabelCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), theme.var.gray400);
};
var devPreviewCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject2(), theme.var.gray50, theme.var.gray300, theme.var.gray200, theme.var.gray300, theme.var.gray400, theme.var.gray700, theme.var.gray500, theme.colors.main500);
};
var AD_UNITS = {
    home_cp_mobile: {
        slot: "1147096797" || 0,
        layoutKey: "-7t+er-i-q+3d" || 0
    },
    home_sr_mobile: {
        slot: "5407973686" || 0,
        layoutKey: "-hj" || 0
    },
    feed_default_mobile: {
        slot: "9380810036" || 0,
        layoutKey: "-fl+5f+76-cs-1m" || 0
    },
    library_mobile: {
        slot: "5316474349" || 0,
        layoutKey: "-bl+bt-3y-7x+tm" || 0
    },
    story_mobile: {
        slot: "9181499480" || 0,
        layoutKey: "-fj+65+1s-bv+er" || 0
    },
    episode_mobile: {
        slot: "8798356107" || 0,
        layoutKey: "-b5+bp-3d-6j+ow" || 0
    }
};
var ADSENSE_CLIENT = "";
var IS_DEV = !!ADSENSE_CLIENT && "object" !== "undefined" && window.location.hostname === "localhost";
// 스크립트 중복 삽입 방지용 모듈 스코프 플래그
var adsenseScriptState = "idle";
var adsenseLoadCallbacks = [];
var NativeInFeedAd = function(param) {
    var unitKey = param.unitKey;
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var insRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var pushedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var adUnit = AD_UNITS[unitKey];
    var isEnabled = !!(ADSENSE_CLIENT && (adUnit === null || adUnit === void 0 ? void 0 : adUnit.slot));
    // IntersectionObserver: 뷰포트 200px 이내 진입 시 로드
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isEnabled && !IS_DEV || !containerRef.current) return;
        var observer = new IntersectionObserver(function(param) {
            var _param = _slicedToArray(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.disconnect();
            }
        }, {
            rootMargin: "200px"
        });
        observer.observe(containerRef.current);
        return function() {
            return observer.disconnect();
        };
    }, [
        isEnabled
    ]);
    // AdSense 스크립트 로드 + push
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isEnabled || !isVisible || pushedRef.current || IS_DEV) return;
        var pushAd = function() {
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
                pushedRef.current = true;
            } catch (e) {
                console.warn("[AdSense InFeed] push error:", e);
            }
        };
        if (adsenseScriptState === "loaded") {
            pushAd();
            return;
        }
        if (adsenseScriptState === "loading") {
            adsenseLoadCallbacks.push(pushAd);
            return;
        }
        // 최초 1회 스크립트 삽입
        adsenseScriptState = "loading";
        adsenseLoadCallbacks.push(pushAd);
        var script = document.createElement("script");
        script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=".concat(ADSENSE_CLIENT);
        script.async = true;
        script.crossOrigin = "anonymous";
        script.onload = function() {
            adsenseScriptState = "loaded";
            adsenseLoadCallbacks.forEach(function(cb) {
                return cb();
            });
            adsenseLoadCallbacks.length = 0;
        };
        script.onerror = function() {
            adsenseScriptState = "idle";
            adsenseLoadCallbacks.length = 0;
            console.warn("[AdSense InFeed] script load failed");
        };
        document.head.appendChild(script);
    }, [
        isEnabled,
        isVisible
    ]);
    // 로드 완료 감지 + 타임아웃 시 숨김
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!insRef.current || !isVisible || IS_DEV) return;
        var loaded = false;
        var observer = new MutationObserver(function() {
            var ref;
            if (((ref = insRef.current) === null || ref === void 0 ? void 0 : ref.getAttribute("data-ad-status")) === "unfilled") {
                var ref1, ref2;
                (ref1 = containerRef.current) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("adsense-loaded");
                (ref2 = containerRef.current) === null || ref2 === void 0 ? void 0 : ref2.classList.add("adsense-failed");
                return;
            }
            if (insRef.current && insRef.current.childElementCount > 0 && containerRef.current) {
                loaded = true;
                containerRef.current.classList.remove("adsense-failed");
                containerRef.current.classList.add("adsense-loaded");
            }
        });
        observer.observe(insRef.current, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                "data-ad-status"
            ]
        });
        // 5초 내 로드 안 되면 숨김
        var timeout = setTimeout(function() {
            if (!loaded && containerRef.current) {
                containerRef.current.classList.add("adsense-failed");
                observer.disconnect();
            }
        }, 5000);
        return function() {
            observer.disconnect();
            clearTimeout(timeout);
        };
    }, [
        isVisible
    ]);
    if (!isEnabled && !IS_DEV) return null;
    // 로컬 개발 환경: 미리보기 플레이스홀더
    if (IS_DEV) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
            ref: containerRef,
            css: devPreviewCSS,
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                    className: "dev-ad-icon",
                    children: "AD"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                    className: "dev-ad-content",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                            className: "dev-ad-label",
                            children: [
                                "AdSense InFeed \xb7 ",
                                unitKey
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                            className: "dev-ad-title",
                            children: "광고 제목이 여기에 표시됩니다"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                            className: "dev-ad-body",
                            children: "광고 설명 텍스트 미리보기"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
                    type: "button",
                    className: "dev-ad-cta",
                    children: "자세히"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        ref: containerRef,
        css: containerCSS,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                css: adLabelCSS,
                children: "광고"
            }),
            isVisible && adUnit && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ins", {
                ref: insRef,
                className: "adsbygoogle",
                style: {
                    display: "block"
                },
                "data-ad-format": "fluid",
                "data-ad-layout-key": adUnit.layoutKey,
                "data-ad-client": ADSENSE_CLIENT,
                "data-ad-slot": adUnit.slot
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NativeInFeedAd);


/***/ }),

/***/ 99598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71618);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54909);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79825);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82740);
/* harmony import */ var _components_common_Avatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81649);
/* harmony import */ var _api_live__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25409);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39819);
/* harmony import */ var _contexts_auth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31779);
/* harmony import */ var _utils_hook__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97033);
/* harmony import */ var _utils_liveMedia__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92126);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81946);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    border-bottom: 1px solid ",
        ";\n    padding: ",
        "px 0;\n\n    h5 {\n      padding: 0 ",
        "px;\n      margin-bottom: ",
        "px;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  display: flex;\n  width: 100%;\n  min-height: 52px;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 ",
        "px;\n  color: ",
        ";\n  text-align: left;\n\n  .heading {\n    display: inline-flex;\n    align-items: center;\n    gap: ",
        "px;\n    font-weight: 700;\n  }\n\n  .live-dot {\n    width: 7px;\n    height: 7px;\n    flex: 0 0 7px;\n    border-radius: ",
        "px;\n    background-color: ",
        ";\n  }\n\n  .summary {\n    ",
        ";\n    display: inline-flex;\n    align-items: center;\n    gap: ",
        "px;\n    color: ",
        ";\n  }\n\n  .summary-avatars {\n    display: inline-flex;\n    padding-left: 8px;\n  }\n\n  .summary-avatar {\n    display: inline-flex;\n    margin-left: -8px;\n    overflow: hidden;\n    border: 2px solid ",
        ";\n    border-radius: ",
        "px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        "px;\n  padding: 0 ",
        "px ",
        "px;\n  overflow-x: auto;\n  overscroll-behavior-x: contain;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 84px;\n  flex: 0 0 84px;\n  text-align: center;\n  cursor: pointer;\n\n  .avatar-ring {\n    display: inline-flex;\n    padding: 3px;\n    border: 2px solid ",
        ";\n    border-radius: ",
        "px;\n  }\n\n  .avatar-crop {\n    display: inline-flex;\n    width: 44px;\n    height: 44px;\n    overflow: hidden;\n    border-radius: 50%;\n  }\n\n  strong,\n  small {\n    display: block;\n  }\n\n  strong {\n    ",
        ";\n    margin-top: ",
        "px;\n  }\n\n  small {\n    ",
        ";\n    color: ",
        ";\n    margin-top: 2px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  width: 64px;\n  height: 64px;\n  flex: 0 0 64px;\n  border-radius: ",
        "px;\n  background-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}














var HOME_LIVE_COLLAPSED_STORAGE_KEY = "homeLiveDiscoveryCollapsed";
var containerCSS = function(collapsible) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__.css)(_templateObject(), collapsible && "border-top: 1px solid ".concat(theme.border.light, ";"), theme.border.light, collapsible ? 0 : chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small);
    };
};
var toggleCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__.css)(_templateObject1(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body14 */ .ZT.body14, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, theme.var.black, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Radius.round */ .wU.round, theme.colors.red500, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body12 */ .ZT.body12, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, theme.var.gray500, theme.var.white, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Radius.round */ .wU.round);
};
var listCSS = function(collapsible) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__.css)(_templateObject2(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, collapsible ? chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small : 0);
};
var itemCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__.css)(_templateObject3(), theme.colors.red500, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Radius.round */ .wU.round, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body12 */ .ZT.body12, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body11 */ .ZT.body11, theme.var.gray500);
};
var moreCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__.css)(_templateObject4(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body12 */ .ZT.body12, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Radius.round */ .wU.round, theme.var.gray100, theme.var.gray600);
};
var LiveDiscoveryList = function(param) {
    var _collapsible = param.collapsible, collapsible = _collapsible === void 0 ? false : _collapsible;
    var ref;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
    var openPageOrMove = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_11__/* .useWebView */ .B9)().openPageOrMove;
    var status = (0,_contexts_auth__WEBPACK_IMPORTED_MODULE_8__/* .useAuthStore */ .tN)().status;
    var ref1 = (0,_utils_hook__WEBPACK_IMPORTED_MODULE_9__/* .useMe */ .Pi)({
        enabled: status === "success"
    }), me = ref1.data;
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQueryClient)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isCollapsed = ref2[0], setIsCollapsed = ref2[1];
    var queryKey = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return _constants__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEYS.LIVE.DISCOVERY */ .U7.LIVE.DISCOVERY(me === null || me === void 0 ? void 0 : me.id);
    }, [
        me === null || me === void 0 ? void 0 : me.id
    ]);
    var _next;
    var query = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery)(queryKey, function(param) {
        var pageParam = param.pageParam;
        return (0,_api_live__WEBPACK_IMPORTED_MODULE_6__/* .fetchLiveDiscovery */ .Do)(pageParam);
    }, {
        enabled: _constants__WEBPACK_IMPORTED_MODULE_7__/* .LIVE_FEATURE_ENABLED */ .sv && status === "success" && !!(me === null || me === void 0 ? void 0 : me.id),
        suspense: false,
        retry: false,
        staleTime: 30 * 1000,
        refetchOnMount: "always",
        refetchOnWindowFocus: "always",
        getNextPageParam: function(lastPage) {
            return (_next = lastPage.next) !== null && _next !== void 0 ? _next : undefined;
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (status !== "success") {
            queryClient.removeQueries([
                "live",
                "discovery"
            ]);
        }
    }, [
        queryClient,
        status
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!collapsible || "object" === "undefined") {
            return;
        }
        try {
            setIsCollapsed(window.localStorage.getItem(HOME_LIVE_COLLAPSED_STORAGE_KEY) === "true");
        } catch (e) {
            setIsCollapsed(false);
        }
    }, [
        collapsible
    ]);
    var sessions = (ref = query.data) === null || ref === void 0 ? void 0 : ref.pages.reduce(function(items, page) {
        var seen = new Set(items.map(function(item) {
            return item.id;
        }));
        return items.concat(page.results.filter(function(item) {
            return !seen.has(item.id);
        }));
    }, []);
    var removeSession = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(liveId) {
        queryClient.setQueryData(queryKey, function(current) {
            return current ? _objectSpreadProps(_objectSpread({}, current), {
                pages: current.pages.map(function(page) {
                    return _objectSpreadProps(_objectSpread({}, page), {
                        results: page.results.filter(function(item) {
                            return item.id !== liveId;
                        })
                    });
                })
            }) : current;
        });
    }, [
        queryClient,
        queryKey
    ]);
    var handleOpen = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = _asyncToGenerator(function(liveId) {
            var session, error, ref;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,_api_live__WEBPACK_IMPORTED_MODULE_6__/* .fetchLiveSession */ .n5)(liveId)
                        ];
                    case 1:
                        session = _state.sent();
                        if (session.status !== "live") {
                            removeSession(liveId);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            openPageOrMove("/lives/".concat(liveId))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        if (axios__WEBPACK_IMPORTED_MODULE_2___default().isAxiosError(error) && ((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 404) {
                            removeSession(liveId);
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(liveId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        openPageOrMove,
        removeSession
    ]);
    var loadNext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ _asyncToGenerator(function() {
        var error, ref;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!query.hasNextPage || query.isFetchingNextPage) {
                        return [
                            2
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        6
                    ]);
                    return [
                        4,
                        query.fetchNextPage()
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 3:
                    error = _state.sent();
                    if (!(axios__WEBPACK_IMPORTED_MODULE_2___default().isAxiosError(error) && ((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 404)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        queryClient.resetQueries(queryKey, {
                            exact: true
                        })
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    }), [
        query,
        queryClient,
        queryKey
    ]);
    var handleScroll = function(event) {
        var list = event.currentTarget;
        if (list.scrollWidth - list.scrollLeft - list.clientWidth < 120) {
            void loadNext();
        }
    };
    var handleToggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setIsCollapsed(function(current) {
            var next = !current;
            try {
                window.localStorage.setItem(HOME_LIVE_COLLAPSED_STORAGE_KEY, String(next));
            } catch (e) {
            // WebView 저장소를 사용할 수 없어도 현재 화면의 접기/펼치기는 유지한다.
            }
            return next;
        });
    }, []);
    if (!_constants__WEBPACK_IMPORTED_MODULE_7__/* .LIVE_FEATURE_ENABLED */ .sv || !query.isFetched || !sessions || sessions.length === 0) {
        return null;
    }
    var sessionCountLabel = "".concat(sessions.length).concat(query.hasNextPage ? "+" : "");
    var _picture, ref3, _nickname;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("section", {
        css: containerCSS(collapsible),
        "aria-label": "진행 중인 라이브",
        children: [
            collapsible ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("button", {
                type: "button",
                css: toggleCSS,
                "aria-controls": "live-discovery-list",
                "aria-expanded": !isCollapsed,
                "aria-label": "라이브 목록 ".concat(isCollapsed ? "펼치기" : "접기"),
                onClick: handleToggle,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("span", {
                        className: "heading",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("span", {
                                className: "live-dot",
                                "aria-hidden": "true"
                            }),
                            "지금 라이브 중"
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("span", {
                        className: "summary",
                        children: [
                            isCollapsed && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("span", {
                                className: "summary-avatars",
                                "aria-hidden": "true",
                                children: sessions.slice(0, 3).map(function(session) {
                                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("span", {
                                        className: "summary-avatar",
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_common_Avatar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                            id: session.author.id,
                                            picture: (_picture = session.author.picture) !== null && _picture !== void 0 ? _picture : undefined,
                                            size: _components_common_Avatar__WEBPACK_IMPORTED_MODULE_5__/* .AvatarSize.small */ .DZ.small,
                                            hideDecoration: true
                                        })
                                    }, session.id);
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("span", {
                                children: [
                                    sessionCountLabel,
                                    "개"
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                icon: isCollapsed ? chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .ArrowDown */ .K5 : chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .ArrowUp */ .a2,
                                size: chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Sizes.xsmall */ .u8.xsmall,
                                color: theme.var.gray500
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("h5", {
                children: "지금 라이브 중"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("div", {
                id: collapsible ? "live-discovery-list" : undefined,
                css: listCSS(collapsible),
                hidden: isCollapsed,
                onScroll: handleScroll,
                children: !isCollapsed && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.Fragment, {
                    children: [
                        sessions.map(function(session) {
                            var ref, ref1;
                            /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("button", {
                                type: "button",
                                css: itemCSS,
                                onClick: function() {
                                    return void handleOpen(session.id);
                                },
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("span", {
                                        className: "avatar-ring",
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("span", {
                                            className: "avatar-crop",
                                            "data-live-avatar-crop": "true",
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_common_Avatar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                                id: (ref = session.author) === null || ref === void 0 ? void 0 : ref.id,
                                                picture: (ref3 = (ref1 = session.author) === null || ref1 === void 0 ? void 0 : ref1.picture) !== null && ref3 !== void 0 ? ref3 : undefined,
                                                size: _components_common_Avatar__WEBPACK_IMPORTED_MODULE_5__/* .AvatarSize.large */ .DZ.large,
                                                hideDecoration: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("strong", {
                                        className: "ellipsis",
                                        children: (_nickname = session.author.nickname) !== null && _nickname !== void 0 ? _nickname : "작가"
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("small", {
                                        className: "ellipsis",
                                        children: [
                                            (0,_utils_liveMedia__WEBPACK_IMPORTED_MODULE_10__/* .getLiveKindLabel */ .tC)(session.kind),
                                            " \xb7",
                                            " ",
                                            session.title || "라이브 중"
                                        ]
                                    })
                                ]
                            }, session.id);
                        }),
                        query.hasNextPage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("button", {
                            type: "button",
                            css: moreCSS,
                            disabled: query.isFetchingNextPage,
                            onClick: function() {
                                return void loadNext();
                            },
                            children: "더보기"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LiveDiscoveryList);


/***/ })

}]);